import autobind from 'autobind-decorator';
import * as React from 'react';
import { connect } from 'react-redux';
import { SearchSelection } from '@shared/ui-components';

import { RequestStatus } from 'common/enums/request-status';
import { State as ReduxState } from 'common/interfaces/state';
import { ShortRole } from '../../interfaces/short-role';
import { ShortUserWithRole } from '../../interfaces/short-user';


export interface AttachedUser {
  guid: string;
  roleGroup: string;
  isOwner: boolean;
}

interface ReduxProps {
  roles: ShortRole[];
  loadRolesStatus: RequestStatus;
}

interface DialogUserItemProps extends ReduxProps {
  shortUser: ShortUserWithRole;
  onAttach?: (userGuid: string, roleId: number) => void;
  onDetach?: (userGuid: string) => void;
  onChangeRole?: (userGuid: string, roleId: number) => void;
  attached?: AttachedUser;
}

interface State {
  selectedRoleId: number;
}

class DialogUserItemComponent extends React.Component<DialogUserItemProps, State>  {
  constructor(props: DialogUserItemProps) {
    super(props);

    let role: ShortRole;
    if (props.attached) {
      role = props.roles.find((r) => r.roleGroup === props.attached.roleGroup);
      this.state = {
        selectedRoleId: role && role.id,
      };
    } else {
      this.state = {
        selectedRoleId: null,
      };
    }
  }

  public componentDidUpdate(prevProps: DialogUserItemProps): void {
    if (
      prevProps.loadRolesStatus === RequestStatus.Loaded &&
      this.props.loadRolesStatus === RequestStatus.Loading
    ) {
      if (this.props.attached) {
        const role = this.props.roles.find((r) => r.roleGroup === this.props.attached.roleGroup);

        this.setState({
          selectedRoleId: role.id,
        });
      }
    }
  }

  public render(): React.ReactNode {
    const { roles, attached } = this.props;
    return (
      <div className='admin-item with-select'>
        <div className='admin-item__information'>
          <span className='admin-item__head two-lines'>
            {`${this.props.shortUser.firstName} ${this.props.shortUser.lastName}`}
            <span className='admin-item__secondary'> (
              {`${this.props.shortUser.email}`})
            </span>
          </span>
          <span className='admin-item__select-wrapper'>
            <SearchSelection
              header={'Role for employee'}
              elements={roles.map(p => p.name)}
              activeElementIndexes={[roles.findIndex(r => r.id === this.state.selectedRoleId)]}
              onClick={this.onChangeRole}
              closeAfterClick={true}
              disabled={attached && attached.isOwner}
            />
          </span>
        </div>
      </div>
    );
  }

  @autobind
  private onChangeRole(index: number): void {
    const { roles } = this.props;
    const role = roles[index];
    this.changeRole(role && role.id);
  }

  @autobind
  private changeRole(newRoleId: number): void {
    this.setState({
      selectedRoleId: newRoleId,
    },            () => {
      if (this.state.selectedRoleId) {
        if (this.props.attached) {
          if (this.props.onChangeRole) {
            this.props.onChangeRole(
              this.props.shortUser.guid,
              this.state.selectedRoleId,
            );
          }
        } else {
          this.props.onAttach(this.props.shortUser.guid, this.state.selectedRoleId);
        }
      } else if (this.props.attached) {
        this.props.onDetach(this.props.shortUser.guid);
      }
    });
  }
}

const mapStateToProps = (state: ReduxState): ReduxProps => {
  const companiesState = state.admin.companies;
  const detachOption: ShortRole = { id: null, name: '', roleGroup: null };
  return {
    roles: [detachOption, ...companiesState.selectedCompanyRoles],
    loadRolesStatus: companiesState.statuses.loadCompanyRoles,
  };
};

export const DialogUserItem = connect(mapStateToProps)(DialogUserItemComponent);
